import { render, staticRenderFns } from "./map2.vue?vue&type=template&id=04ebf362&scoped=true&"
import script from "./map2.vue?vue&type=script&lang=js&"
export * from "./map2.vue?vue&type=script&lang=js&"
import style0 from "./map2.vue?vue&type=style&index=0&id=04ebf362&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebf362",
  null
  
)

export default component.exports